(() => {
  const main = document.querySelector('#MainContent.gds-b-pages');
  if (!main || main.querySelector('.hc-document')) return;
  const body = main.querySelector('.standard_page__description:has(.help-center-rich-text--faq), .shopify-policy__body');
  const content = body?.querySelector('.help-center-rich-text--faq, .rte');
  if (!content) return;
  const headings = [...content.children].filter(node => node.tagName === 'H2');
  if (headings.length < 2) return;
  const layout = document.createElement('div');
  layout.className = 'hc-document';
  const nav = document.createElement('nav');
  nav.className = 'hc-document__nav';
  nav.setAttribute('aria-label', main.querySelector('h1')?.textContent.trim() || document.title);
  const label = document.createElement('p');
  label.className = 'hc-document__eyebrow';
  label.textContent = 'On this page';
  nav.append(label);
  const list = document.createElement('ol');
  nav.append(list);
  const nodes = [...content.childNodes];
  let panel = document.createElement('div');
  panel.className = 'hc-document__intro';
  content.append(panel);
  nodes.forEach(node => {
    if (headings.includes(node)) {
      const index = headings.indexOf(node);
      if (!node.id) {
        let id = `hc-topic-${index + 1}`;
        while (document.getElementById(id)) id += '-section';
        node.id = id;
      }
      node.setAttribute('tabindex', '-1');
      panel = document.createElement('section');
      panel.className = 'hc-document__section';
      panel.setAttribute('aria-labelledby', node.id);
      content.append(panel);
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'no-scroll';
      link.href = `#${node.id}`;
      link.textContent = node.textContent.trim();
      link.addEventListener('click', event => {
        event.preventDefault();
        const header = document.querySelector('.section-header');
        const announcement = document.querySelector('.section-announcement-bar, .announcement-bar-section');
        const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0, announcement?.getBoundingClientRect().bottom || 0) + 24;
        node.focus({preventScroll:true});
        window.scrollTo({top:window.scrollY + node.getBoundingClientRect().top - offset, behavior:'instant'});
        history.replaceState(null, '', link.hash);
      });
      item.append(link);
      list.append(item);
    }
    panel.append(node);
  });
  // Preserve Page-owned destinations while making each support tile one native link.
  if (content.matches('.help-center-rich-text--faq')) {
    content.querySelectorAll('.hc-document__intro > ul > li').forEach(item => {
      const link = item.querySelector('a');
      const source = link?.parentElement;
      if (!link || source.tagName !== 'STRONG' || item.querySelectorAll('a').length !== 1) return;
      const labelText = [...source.childNodes].filter(node => node !== link).map(node => node.textContent).join('').trim();
      if (!labelText) return;
      const title = document.createElement('span');
      title.className = 'hc-contact__label';
      title.textContent = labelText;
      const detail = document.createElement('span');
      detail.className = 'hc-contact__detail';
      detail.append(...link.childNodes);
      link.replaceChildren(title, detail);
      item.replaceChildren(link);
    });
  }
  if (location.pathname.replace(/\/$/, '') === '/policies/shipping-policy') {
    const section = [...content.querySelectorAll('.hc-document__section')]
      .find(node => node.querySelector('h2')?.textContent.trim() === 'Order Tracking');
    const link = section?.querySelector('a[href="https://www.euronavigate.com/apps/tracking"], a[href="/apps/tracking"]');
    const paragraph = link?.closest('p');
    if (paragraph) {
      paragraph.textContent = "Once your product has been shipped, you can track your order through the carrier's official website. Use the tracking information provided in your confirmation email to monitor the progress of your shipment.";
      const instruction = document.createElement('p');
      instruction.textContent = 'To view your shipping progress on our website, use the Order Tracking Page button below.';
      const action = document.createElement('p');
      link.classList.add('hc-tracking-button');
      link.setAttribute('href', '/apps/tracking');
      link.removeAttribute('target');
      action.append(link);
      const divider = section.querySelector('hr');
      if (divider) divider.before(instruction, action);
      else section.append(instruction, action);
    }
  }
  if (!content.firstElementChild.textContent.trim()) content.firstElementChild.remove();
  body.before(layout);
  layout.append(nav, body);
  const links = [...list.querySelectorAll('a')];
  let queued = false;
  const update = () => {
    queued = false;
    const header = document.querySelector('.section-header');
    const announcement = document.querySelector('.section-announcement-bar, .announcement-bar-section');
    const offset = Math.max(0, header?.getBoundingClientRect().bottom || 0, announcement?.getBoundingClientRect().bottom || 0) + 24;
    layout.style.setProperty('--hc-guide-offset', `${offset}px`);
    let active = 0;
    headings.forEach((heading, index) => { if (heading.getBoundingClientRect().top <= offset + 60) active = index; });
    links.forEach((link, index) => {
      if (index === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule);
  update();
})();
